// extracted by mini-css-extract-plugin
module.exports = {"card":"_3ThsR","cardWarning":"_1e1r2","description":"_2Qoo4","warning":"_2eD1X","map":"Qcg9H"};